import axios from '../helpers/Axios'

export default {

  async loadLookups() {
    return await axios.get("/Lookups",  {timeout: 1000 * 120});
  },

  async loadPostcodeArea(countryCode) {
    return await axios.get("/Lookups/postcodes/" + countryCode);
  },

  async loadRegions() {
    return await axios.get("/Lookups/regions");
  },
}
